import { useEffect, useRef, useState } from 'react';
import { TextInput } from '@/components';
import { useDebounce } from '@/hooks';

interface TagFilterInputProps {
  value: string;
  onChange: (tag: string) => void;
}

// Input de etiqueta con debounce: evita disparar una request por cada tecla.
// `value` es la fuente de verdad del filtro; sincronizamos hacia abajo solo
// cuando el cambio viene de afuera (por ejemplo, "Limpiar filtros").
const TagFilterInput = ({ value, onChange }: TagFilterInputProps) => {
  const [input, setInput] = useState(value);
  const debounced = useDebounce(input, 400);
  const lastEmitted = useRef(value);

  useEffect(() => {
    if (debounced !== lastEmitted.current) {
      lastEmitted.current = debounced;
      onChange(debounced);
    }
  }, [debounced, onChange]);

  useEffect(() => {
    if (value !== lastEmitted.current) {
      lastEmitted.current = value;
      setInput(value);
    }
  }, [value]);

  return (
    <TextInput
      name='tagFilter'
      placeholder='Etiqueta'
      value={input}
      onChange={(next) => setInput(String(next))}
    />
  );
};

export default TagFilterInput;
